document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const header = document.querySelector('.site-header');
  const menu = document.querySelector('[data-mobile-menu]');
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuClose = document.querySelector('[data-menu-close]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchOpeners = document.querySelectorAll('[data-search-open]');
  const searchClosers = document.querySelectorAll('[data-search-close]');


  const setScrollLock = (locked) => body.classList.toggle('no-scroll', locked);

  const resetMobileSubmenus = () => {
    if (!menu) return;
    menu.querySelectorAll('.mobile-menu__group.is-expanded').forEach((group) => {
      group.classList.remove('is-expanded');
      const trigger = group.querySelector(':scope > .mobile-menu__top');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const openMenu = () => {
    if (!menu) return;
    resetMobileSubmenus();
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    setScrollLock(true);
    const firstLink = menu.querySelector('a, button');
    if (firstLink) firstLink.focus();
  };

  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    resetMobileSubmenus();
    setScrollLock(false);
    if (menuOpen) menuOpen.focus();
  };

  if (menuOpen) menuOpen.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);

  if (menu) {
    menu.querySelectorAll('.mobile-menu__group').forEach((group, index) => {
      const children = group.querySelector(':scope > .mobile-menu__children, :scope > .mobile-menu__catalog-grid');
      const trigger = group.querySelector(':scope > .mobile-menu__top');
      if (!children || !trigger) return;

      group.classList.add('has-mobile-children');
      const submenuId = `mobile-submenu-${index + 1}`;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', submenuId);
      children.id = submenuId;

      trigger.addEventListener('click', (event) => {
        if (!window.matchMedia('(max-width: 860px)').matches) return;
        event.preventDefault();
        const isOpen = group.classList.toggle('is-expanded');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  const openSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    setScrollLock(true);
    const input = searchOverlay.querySelector('input');
    window.setTimeout(() => input && input.focus(), 20);
  };

  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    setScrollLock(false);
  };

  searchOpeners.forEach((button) => button.addEventListener('click', openSearch));
  searchClosers.forEach((button) => button.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (menu && menu.classList.contains('is-open')) closeMenu();
      if (searchOverlay && !searchOverlay.hidden) closeSearch();
    }
  });

  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantsScript = form.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }
    if (!variants.length) return;

    const page = form.closest('[data-product-page]');
    const groups = Array.from(form.querySelectorAll('[data-option-group]'));
    const variantInput = form.querySelector('[data-variant-id-input]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const priceBox = page ? page.querySelector('[data-product-price]') : null;
    const galleryItems = page ? Array.from(page.querySelectorAll('[data-gallery-image-id]')) : [];

    const getSelectedValues = () => groups.map((group) => {
      const selected = group.querySelector('[data-option-button].is-selected');
      return selected ? selected.dataset.optionValue : '';
    });

    const sameOptions = (variant, selected) => variant.options.every((value, index) => value === selected[index]);

    const syncButtons = (variant) => {
      groups.forEach((group, index) => {
        const selectedValue = variant.options[index];
        const selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = selectedValue;

        group.querySelectorAll('[data-option-button]').forEach((button) => {
          const selected = button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    };

    const updateGallery = (variant) => {
      if (!variant.imageId || !galleryItems.length) return;
      const target = galleryItems.find((item) => String(item.dataset.galleryImageId) === String(variant.imageId));
      if (!target) return;

      galleryItems.forEach((item) => item.classList.remove('is-primary'));
      target.classList.add('is-primary');

      if (window.matchMedia('(max-width: 860px)').matches) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(() => target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' }), 20);
      }
    };

    const updatePrice = (variant) => {
      if (!priceBox) return;
      const saleClass = variant.compareAtPrice ? ' price--sale' : '';
      const compare = variant.compareAtPrice ? `<s>${variant.compareAtPrice}</s>` : '';
      priceBox.innerHTML = `<span class="price${saleClass}"><span>${variant.price}</span>${compare}</span>`;
    };

    const applyVariant = (variant) => {
      if (!variant) return;
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncButtons(variant);
      updatePrice(variant);
      updateGallery(variant);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.unavailableLabel;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    form.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const position = Number(button.dataset.optionPosition) - 1;
        const selected = getSelectedValues();
        selected[position] = button.dataset.optionValue;

        let variant = variants.find((candidate) => sameOptions(candidate, selected));
        if (!variant) {
          variant = variants.find((candidate) => candidate.options[position] === button.dataset.optionValue && candidate.available)
            || variants.find((candidate) => candidate.options[position] === button.dataset.optionValue);
        }
        applyVariant(variant);
      });
    });

    const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput ? variantInput.value : '')) || variants[0];
    syncButtons(initialVariant);
  });
});

